//提示框
export function Toastinit(params) {
  /*设置信息框停留的默认时间*/
  let time = params.time;
  if (time == undefined || time == "") {
    time = 1500;
  }
  let el = document.createElement("div");
  el.setAttribute("class", "web-toast");
  //   el.innerHTML = params.message;
  let icon = document.createElement("i");
  let iconClass = "";
  switch (params.type) {
    case "success":
      iconClass = "el-icon-success";
      break;
    case "error":
      iconClass = "el-icon-warning";
      break;
    default:
      iconClass = "el-icon-info";
      break;
  }
  icon.setAttribute("class", iconClass);
  el.appendChild(icon);
  let span = document.createElement("span");
  span.innerHTML = params.message;
  el.appendChild(span);
  document.body.appendChild(el);
  el.classList.add("fadeIn");
  setTimeout(function() {
    el.classList.remove("fadeIn");
    el.classList.add("fadeOut");
    /*监听动画结束，移除提示信息元素*/
    el.addEventListener("animationend", function() {
      document.body.removeChild(el);
    });
    el.addEventListener("webkitAnimationEnd", function() {
      document.body.removeChild(el);
    });
  }, time);
}



// WEBPACK FOOTER //
// ./src/utils/toast.js